import React from "react";
import { FaCheck } from "react-icons/fa";

import property from "../../assets/about/property.png";
import apartment from '../../assets/about/apartment.png'
import hook from '../../assets/about/hook.png'
import plot from '../../assets/about/plot.png'
import mission from '../../assets/about/mission.jpeg'
import vission from '../../assets/about/vission.jpg'

const About = () => {
  const aboutdata = [
    {
      id: 0,
      img: property,
      title: "Residential Real Estate Investment",
      desc: "We offer premium luxury apartments, villas, and gated community properties in Noida, Gurugram, Delhi, Mumbai, Goa, and other major cities. Our residential investment portfolio includes projects that guarantee high capital appreciation and rental yield."
    },
    {
      id: 1,
      img: apartment,
      title: "Commercial Property Investment",
      desc: "For investors looking to diversify their portfolio, we provide the best pre-leased commercial spaces, office buildings, retail shops, and co-working spaces in top business hubs. Invest in Grade A commercial properties for steady rental income and long term appreciation."
    },
    {
      id: 2,
      img: hook,
      title: "Pre-Launch & Under Construction Properties",
      desc: "We help investors secure exclusive pre-launch and under construction properties at the best prices, ensuring maximum appreciation before project completion."
    },
    {
      id: 3,
      img: plot,
      title: "Land & Plot Investments",
      desc: "Our land investment advisory services help clients invest in RERA-approved plots in high-growth corridors, ensuring lucrative long-term gains."
    }
  ]
  return (
    <>
      <div className="bg-gray-100 text-gray-800 py-12 px-6 md:px-12 lg:px-20 mt-4">
        <div className="max-w-6xl mx-auto text-center mb-4">
          <h1 className="text-4xl font-bold text-green-600 mt-10 mb-4">
            Welcome to INVESTYCOONS
          </h1>
          <p className="text-xl leading-relaxed font-semibold" >
            Where Real Estate is all about Real Deals & Real Advice
          </p>
        </div>
        <section className="p-4">
          <p className="text-gray-700 text-justify">
            Welcome to Investycoons, a <strong> leading real estate investment company </strong> in
            <strong> Delhi NCR</strong>. Our mission is to provide high-value
            property investment opportunities that maximize returns for
            investors. Whether you're looking to invest in <strong>luxury apartments,
              commercial properties, residential plots </strong>, or <strong> pre-leased properties</strong>,
            we ensure you get the best deals in the market.
          </p>
        </section>
      </div>

      <section className="py-12 px-6 md:px-12 lg:px-20 mt-4">
        <div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 my-6">
            Who <span className="text-green-600">We Are</span>
          </h1>

          <p className="text-gray-700 text-justify">
            At Investycoons, we specialize in real estate consulting, property investment advisory, and wealth-building strategies through real estate.
            We bring together years of expertise in the Indian real estate sector, offering curated investment options from top developers like
            <strong> Godrej Properties, ATS Infrastructure, Prestige Group, DLF</strong>, and <strong>more</strong>.
          </p>

          <p className="text-gray-700 text-justify mt-4">
            We are not just real estate consultants – we are your partners in financial growth through strategic property investments.
            Our team of experts evaluates market trends, high-growth locations, RERA-approved properties, and high ROI projects to ensure
            our clients make informed investment decisions.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-12 px-6 md:px-12 lg:px-20 mt-4 bg-gray-100">
        <div className="">
          <h1 className="text-4xl font-bold text-gray-900 my-6">
            Our <span className="text-green-600">Services</span>
          </h1>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
          {aboutdata.map((data, index) => (
            <div className="bg-white shadow-lg rounded-lg p-6">
              <div className="flex justify-center">
                <img
                  src={data.img}
                  alt="Residential Property"
                  className="w-[60px] h-[60px] object-cover rounded-md"
                />
              </div>
              <h3 className="text-2xl font-semibold pt-3 pb-2 text-center">
                {data.title}
              </h3>
              <p className="text-gray-700 text-justify">
                {data.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-12 px-6 md:px-12 lg:px-20 mt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

          {/* Text Section */}
          <div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 my-6">
              Our Vision – <span className="text-green-600">Shaping the Future of Real Estate Investment</span>
            </h1>
            <p className="text-gray-700 text-justify">
              At Investycoons, our vision is to make real estate investment transparent, seamless, and highly profitable for individuals and businesses.
              We aim to redefine the Indian real estate market by offering trusted advisory, smart investment solutions, and unparalleled market access to investors worldwide.
            </p>

            <h5 className="mt-4 text-lg md:text-xl text-gray-800 font-semibold">We envision a world where:</h5>
            <ul className="list-none p-0 mt-3 space-y-3">
              <li className="text-gray-800 text-[15px] md:text-[16px] font-semibold flex items-start gap-2 text-justify">
                <FaCheck className="text-green-600 shrink-0 mt-1 md:mt-0" />
                Investing in real estate is simple, strategic, and rewarding.
              </li>
              <li className="text-gray-800 text-[15px] md:text-[16px] font-semibold flex items-start gap-2 text-justify">
                <FaCheck className="text-green-600 shrink-0 mt-1 md:mt-0" />
                Clients can access high ROI properties with complete transparency.
              </li>
              <li className="text-gray-800 text-[15px] md:text-[16px] font-semibold flex items-start gap-2 text-justify">
                <FaCheck className="text-green-600 shrink-0 mt-1 md:mt-0" />
                Investors achieve long-term financial security through smart real estate choices.
              </li>
            </ul>
          </div>

          {/* Image Section */}
          <div className="flex justify-center">
            <img
              className="w-full max-w-[500px] h-auto md:h-[350px] lg:h-[400px] object-cover rounded-lg shadow-lg"
              src={vission}
              alt="Real Estate Vision"
            />
          </div>

        </div>
      </section>


      <section className="py-12 px-6 md:px-12 lg:px-20 mt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div>
            <img
              className="w-full h-auto md:h-[400px] object-cover rounded-lg"
              src={mission}
              alt="Our Mission"
            />
          </div>
          <div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 my-6 text-center md:text-left">
              Our Mission – <span className="text-green-600">Creating Wealth Through Real Estate</span>
            </h1>

            <h5 className="mt-3 text-lg md:text-xl text-gray-800 font-semibold text-center md:text-left">
              Our mission is to empower investors with -
            </h5>

            <ul className="list-none p-0 mt-3 space-y-2 text-justify">
              <li className="text-gray-800 text-base font-semibold flex items-start md:items-center gap-2">
                <FaCheck className="text-green-600 mt-1 md:mt-0" />
                <span>Expert Market Research – Identifying high-growth real estate zones for the best investment opportunities.</span>
              </li>
              <li className="text-gray-800 text-base font-semibold flex items-start md:items-center gap-2">
                <FaCheck className="text-green-600 mt-1 md:mt-0" />
                <span>Exclusive Investment Deals – Providing early access to pre-launch and high-ROI real estate projects.</span>
              </li>
              <li className="text-gray-800 text-base font-semibold flex items-start md:items-center gap-2">
                <FaCheck className="text-green-600 mt-1 md:mt-0" />
                <span>End-to-End Advisory – From property selection to paperwork, making investments seamless.</span>
              </li>
              <li className="text-gray-800 text-base font-semibold flex items-start md:items-center gap-2">
                <FaCheck className="text-green-600 mt-1 md:mt-0" />
                <span>Maximized Returns – Ensuring financial security through high-yield real estate opportunities.</span>
              </li>
              <li className="text-gray-800 text-base font-semibold flex items-start md:items-center gap-2">
                <FaCheck className="text-green-600 mt-1 md:mt-0" />
                <span>Client-Centric Solutions – Offering tailored real estate investment plans for individuals, businesses, and NRIs.</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="py-12 px-6 md:px-12 lg:px-20 mt-4 bg-gray-100">
        <div className="">
          <h1 className="text-4xl font-bold text-gray-900 my-6">
            Our Core Values  <span className="text-green-600"> - The Foundation of Investycoons</span>
          </h1>
          <p>We are driven by a strong set of core values that define our business and the way we serve our clients </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Residential Real Estate Investment */}
          <div className="bg-[#7ede7e96] hover:bg-white shadow-lg rounded-lg p-6 mt-4 ">

            <h3 className="text-2xl font-semibold pt-3 pb-2">
              Transparency
            </h3>
            <p className="text-gray-700 text-justify">
              We provide clear, data-driven insights so you can make informed real estate investment decisions with confidence.
            </p>
          </div>
          <div className="bg-[#7ede7e96] hover:bg-white shadow-lg rounded-lg p-6 mt-4">

            <h3 className="text-2xl font-semibold pt-3 pb-2">
              Integrity
            </h3>
            <p className="text-gray-700 text-justify">
              We uphold the highest standards of honesty and ethical business practices in every transaction.
            </p>
          </div>
          <div className="bg-[#7ede7e96] hover:bg-white shadow-lg rounded-lg p-6 mt-4">

            <h3 className="text-2xl font-semibold pt-3 pb-2">
              Innovation
            </h3>
            <p className="text-gray-700 text-justify">
              We embrace cutting-edge real estate analytics, market trends, and AI driven insights to offer the best investment solutions.
            </p>
          </div>
          <div className="bg-[#7ede7e96] hover:bg-white shadow-lg rounded-lg p-6 mt-4">

            <h3 className="text-2xl font-semibold pt-3 pb-2">
              Customer Centric Approach
            </h3>
            <p className="text-gray-700 text-justify">
              Our success is built on trust, long term relationships, and client satisfaction.
            </p>
          </div>
          <div className="bg-[#7ede7e96] hover:bg-white shadow-lg rounded-lg p-6 mt-4">

            <h3 className="text-2xl font-semibold pt-3 pb-2">
              Wealth Creation
            </h3>
            <p className="text-gray-700 text-justify">
              Our goal is to help our clients generate passive income and build financial independence through real estate investments.
            </p>
          </div>
          <div className="bg-[#7ede7e96] hover:bg-white shadow-lg rounded-lg p-6 mt-4">

            <h3 className="text-2xl font-semibold pt-3 pb-2">
              Sustainability
            </h3>
            <p className="text-gray-700 text-justify">
              We believe in promoting eco-friendly, future ready real estate projects that align with sustainable development goals
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 px-6 md:px-12 lg:px-20 mt-4">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 my-6 leading-snug">
            Exploring dream locations but feeling unsure where to start?
          </h1>
          <p className="text-lg font-semibold text-gray-700">
            Leave us a query and our representative will get back to you.
          </p>
          <div className="mt-6">
            <a
              href="/connect"
              className="inline-block bg-green-500 rounded-full text-white px-8 py-3 text-lg font-semibold hover:bg-green-700 transition-all duration-300"
            >
              Get In Touch
            </a>
          </div>
        </div>
      </section>

    </>
  )
}
export default About;